import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Auth } from "../../@core/auth";
import "./LibraryIntro.scss";

const LibraryIntro = ({ recentSongs, toggleSidebar }: any) => {
  const location = useLocation();
  return (
    <div className="library-intro">
      <svg className="library-intro-defs">
        <defs>
          <linearGradient
            id="libArrowGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#4facfe" />
            <stop offset="100%" stopColor="#f093fb" />
          </linearGradient>
        </defs>
      </svg>

      <div className="library-intro-arrows">
        <div
          className="library-intro-arrow library-intro-arrow--left"
          onClick={(e) => toggleSidebar?.("left", e)}
        >
          <FaArrowLeft className="library-intro-arrow-icon" />
          <span className="library-intro-arrow-label">Перелік пісень</span>
        </div>
        <div
          className="library-intro-arrow library-intro-arrow--right"
          onClick={(e) => toggleSidebar?.("right", e)}
        >
          <FaArrowRight className="library-intro-arrow-icon" />
          <span className="library-intro-arrow-label">Медіа ресурси</span>
        </div>
      </div>

      <div className="library-intro-content">
      <div className="library-intro-about">
        <h2 className="library-intro-about-title">ARYN Lyrics</h2>
        <p className="library-intro-about-text">
          Арін Лірікс — це більше, ніж бібліотека християнських пісень. Це
          платформа для музичного служіння, яка допомагає церквам і командам
          прославлення зберігати пісні, створювати власні пісенники, готувати
          добірки, поширювати їх, створювати презентації, відстежувати історію
          виконання та працювати разом. Усе необхідне для організації
          прославлення — в одному місці.
        </p>
        <div className="library-intro-divider">𝄞</div>
        <p className="library-intro-about-hint">
          На цій сторінці зібрані пісні з усіх публічних пісенників ресурсу.
          Якщо ви не знайшли потрібної пісні, створіть власний пісенник і
          поповнюйте його улюбленими піснями.
        </p>
      </div>


      {recentSongs?.length > 0 && (
        <div className="library-intro-recent">
          <h3 className="library-intro-section-title library-intro-section-title--recent">
            Останні поповнення
          </h3>
          <ul className="library-intro-recent-list">
            {recentSongs.slice(0, 12).map((song: any) => (
              <li key={song.id}>
                <Link
                  to={`/library/song/${song.id}${location.search}`}
                  className="library-intro-recent-link"
                >
                  <span className="library-intro-recent-song-title">
                    {song.title}
                  </span>
                  {song.subTitle && (
                    <span className="library-intro-recent-subtitle">
                      {song.subTitle}
                    </span>
                  )}
                  {song.songbook?.title && (
                    <span className="library-intro-recent-songbook">
                      Пісенник: {song.songbook.title}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      {!Auth.isAuthenticated && (
        <div className="library-intro-cta">
          <p className="library-intro-cta-text">
            Створіть обліковий запис і відкрийте всі можливості Aryn Lyrics.
          </p>
          <Link to="/loginmodal" className="btn-mcolor library-intro-cta-btn">
            Зареєструватися
          </Link>
        </div>
      )}
      </div>
    </div>
  );
};

export default LibraryIntro;
